import React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';
import { Trans, useTranslation } from 'react-i18next';

import st from './CrowdThresholdSettingsModal.module.sass';

const TRANSLATION_PREFIX = 'videoAnalytics:form.bags.threshold_settings';

export function BagsThresholdSettingsTooltipPreview() {
  return (
    <div className={st.TooltipPreview}>
      <Trans
        components={{ p: <p /> }}
        i18nKey={`${TRANSLATION_PREFIX}.tooltip_content`}
      />
    </div>
  );
}

export function BagsThresholdSettingsModal() {
  const { t } = useTranslation();

  return (
    <div className={st.ModalBody}>
      <div className={st.Header}>
        <InfoCircleFilledIcon className={st.Icon} />
        <h5>{t(`${TRANSLATION_PREFIX}.title`)}</h5>
      </div>

      <Trans
        components={{
          section: <section className={st.Section} />,
          h6: <h6>{' '}</h6>,
          p: <p />,
          example: <div className={st.Example} />,
          span: <span />,
        }}
        i18nKey={`${TRANSLATION_PREFIX}.modal_content`}
      />
    </div>
  );
}
